/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

import {
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Select,
  Checkbox,
  Input,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { db, auth } from "../../../../firebase";
import { useParams } from "react-router-dom";
import ActionsLog from "../../../../components/common/ActionsLog";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import Emails from "../../../../components/common/Emails";
import Letters from "../../../../components/common/Letters";
import Notes from "../../../../components/common/Notes";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import Texts from "../../../../components/common/Texts";
import UpcomingActivities from "../../../../components/common/UpcomingActivities";
import Financials from "../../components/Financials";
import LeaseInformation from "../../components/LeaseInformation";
import Liability from "../../components/Liability";
import MonthlyCharges from "../../components/MonthlyCharges";
import Pets from "../../components/Pets";
import Tags from "../../components/Tags";
import Status from "../../components/Status";
import Vehicles from "../../components/Vehicles";
import Tenant from "../../components/Tenant";

import "./TenantDetails.css";
import TenantStatus from "../../components/TenantStatus";
import OnlinePortalStatus from "../../components/OnlinePortalStatus";
import TenantProvidedInsurance from "../../components/TenantProvidedInsurance";
import Screening from "../../components/Screening";
import EmergencyContact from "../../components/EmergencyContact";
import LateFeePolicy from "../../components/LateFeePolicy";
import Contact from "../../components/Contact";
import Summary from "../../components/Summary";
import ElectronicCashPayments from "../../components/ElectronicCashPayments";
import Email from "../../../../components/common/Email";
import { toast } from "react-hot-toast";

const { TextArea } = Input;
function TenantDetails() {
  const [tenants, setTenants] = useState([]);
  const [properties, setProperties] = useState([]);
  const [tenant, setTenant] = useState({});
  const [notes, setNotes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenAdditionalTenant, setIsOpenAdditionalTenant] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);

  const [isShowModalTextUnit, setIsShowModalTextUnit] = useState(false);
  const showTextUnitModal = () => {
    setIsShowModalTextUnit(true);
  };
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const { id } = useParams();

  const fetchTenants = () => {
    const tenantRef = collection(db, "companies", companyName, "tenants");

    const unsubscribe = onSnapshot(tenantRef, (snapshot) => {
      const fetchData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setTenants(fetchData);
    });

    // Return the unsubscribe function directly
    return unsubscribe;
  };

  useEffect(() => {
    let unsubscribe;
    if (companyName) {
      unsubscribe = fetchTenants(); // Fetch tenants and set the unsubscribe function
    }

    return () => {
      if (unsubscribe) {
        unsubscribe(); // Unsubscribe the listener when component is unmounted
      }
    };
  }, [companyName]);

  console.log("tenants", tenants);

  useEffect(() => {
    if (companyName) {
      const fetchProperties = async () => {
        try {
          const propertyRef = collection(
            db,
            "companies",
            companyName,
            "properties"
          );
          const snapshot = await getDocs(propertyRef);

          const fetchData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setProperties(fetchData);
        } catch (err) {
          console.log(err);
          toast.error("Error while fetching data", err);
        }
      };
      console.log("properties useEffect in TenantDetails.js");
      fetchProperties();
    }
  }, [companyName]);

  console.log("properties", properties);

  useEffect(() => {
    const newObject = tenants.find((item) => {
      return item.id === id;
    });
    console.log("set tenants useEffect in TenantDetails.js");
    setTenant(newObject);
  }, [tenants, isRefresh]);
  console.log("tenant", tenant);

  const property = properties.find((item) => {
    if (tenant?.propertyId) {
      return item.id === tenant?.propertyId;
    } else {
      return 0;
    }
  });

  console.log("property", property);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const showAdditionalTenanat = () => {
    setIsOpenAdditionalTenant(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setIsShowModalTextUnit(false);
    setIsOpenAdditionalTenant(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setIsShowModalTextUnit(false);
    setIsOpenAdditionalTenant(false);
  };

  const handleUrl = () => {
    window.open("/inspection", "_blank");
  };

  const TenantDetailsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod("Enter Charge", "1", "", "", ""),
      RightBarMethod("Enter Credit", "2", "", "", ""),
      RightBarMethod("Enter Receipt", "3", "", "", ""),
      RightBarMethod(
        "Charge Late Fees",
        "4",
        "",
        "",
        "/accounting/receivables_payments/chargelatefees"
      ),
      RightBarMethod("Move Out Tenants", "5", "", "", ""),
      RightBarMethod("Move Out One Tenant", "6", "", "", ""),
      RightBarMethod("Transfer Tenant", "7", "", "", ""),
      RightBarMethod(
        "Send Lease or Addendum",
        "8",
        "",
        "",
        "/send_lease_addendum"
      ),
      RightBarMethod("Prepare Renewal Offer", "9", "", "", ""),
      RightBarMethod("NYC Lease Renewal", "10", "", "", ""),
      RightBarMethod("Increase Rent", "11", "", "", "/rent_increase"),
      RightBarMethod(
        "New Service Request",
        "12",
        "",
        "",
        "/maintenance/work-orders/service-requests/new"
      ),
      RightBarMethod("Work Orders", "13", "", "", "/maintenance/work-orders"),
      RightBarMethod(
        "Tenant Payable",
        "14",
        "",
        "",
        "/accounting/payables_bills/bills/newtenantpayable"
      ),
      RightBarMethod(
        <span onClick={showAdditionalTenanat}>Add Additional Tenant</span>,
        "15",
        "",
        "",
        ""
      ),
      RightBarMethod("Hide Tenant", "16", "", "", ""),
      RightBarMethod(
        <a onClick={handleUrl}>New Inspection</a>,
        "17",
        "",
        "",
        "/inspection"
      ),
      RightBarMethod("View Inspections", "18", "", "", ""),
      RightBarMethod("View Unit Turn Board", "19", "", "", ""),
      RightBarMethod("Manage Subsidy Programs", "20", "", "", ""),
      RightBarMethod(
        <span onClick={showModal}>Email Unit</span>,
        "21",
        "",
        "",
        ""
      ),
      RightBarMethod(
        <span onClick={showTextUnitModal}>Text Unit</span>,
        "22",
        "",
        "",
        ""
      ),
      RightBarMethod("View Online Portal", "23", "", "", ""),
      RightBarMethod("Download Text History", "24", "", "", ""),
      RightBarMethod("Send Resident Form to Unit", "25", "", "", ""),
    ]),
    RightBarMethod(
      "REPORTS",
      "t2",
      <i className="fa-solid fa-chart-column"></i>,
      [
        RightBarMethod("Tenant Ledger", "24", "", "", "/"),
        RightBarMethod("Tenant Unpaid Charges", "25", "", "", "/"),
        RightBarMethod("Work Order", "26", "", "", "/"),
        RightBarMethod("Activities Summary", "27", "", "", "/"),
        RightBarMethod("Debt Collections Status", "28", "", "", "/"),
        RightBarMethod("Tenant Insurance Coverage", "29", "", "", "/"),
      ]
    ),
    RightBarMethod(
      "LETTERS",
      "t3",
      <i className="fa-solid fa-file-lines"></i>,
      [
        RightBarMethod("3-Day Notices", "30", "", "", "/"),
        RightBarMethod("3-Day Notices", "31", "", "", "/"),
        RightBarMethod("3-Day Notices", "32", "", "", "/"),
      ]
    ),
    RightBarMethod(
      "HELP TOPICS",
      "t4",
      <i className="fa-solid fa-circle-question"></i>,
      [
        RightBarMethod(
          "How to Refund TenantsHow to Refund Tenants",
          "33",
          "",
          "",
          "/"
        ),
        RightBarMethod("Moving Out Tenant", "34", "", "", "/"),
        RightBarMethod("Move Out One Tenant", "35", "", "", "/"),
        RightBarMethod("Online Portal Overview", "36", "", "", "/"),
        RightBarMethod("Collections Checklist", "37", "", "", "/"),
      ]
    ),
  ];

  return (
    <>
      <div className="tenant-details">
        {property && (
          <Summary data={tenant} property={property?.propertyNameAddress} />
        )}
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <Card title="Tenants">
              <Row gutter={[0, 16]}>
                <Col span={24}>
                  <p className="name-container">
                    {tenant?.profileInfo?.firstName}{" "}
                    {tenant?.profileInfo?.lastName}
                  </p>
                </Col>
                <Col span={24}>
                  <Status data={tenant} />
                </Col>
                <Col span={24}>
                  <Tags data={tenant} />
                </Col>
                <Col span={24}>
                  <Liability data={tenant} />
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={12}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <Tenant data={tenant} />
              </Col>
              <Col span={24}>
                <Contact
                  data={tenant}
                  peopleType="Tenant"
                  companyName={companyName}
                  collectionName="tenants"
                />
              </Col>
              <Col span={24}>
                <TenantStatus data={tenant} />
              </Col>
              <Col span={24}>
                <OnlinePortalStatus data={tenant} />
              </Col>
              <Col span={24}>
                <ElectronicCashPayments />
              </Col>
              <Col span={24}>
                <TenantProvidedInsurance data={tenant} />
              </Col>
              <Col span={24}>
                <Screening data={tenant} />
              </Col>
              <Col span={24}>
                <EmergencyContact data={tenant} />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <UpcomingActivities />
          </Col>
          <Col span={24}>
            {companyName ? (
              <Notes
                notesForCollection="tenants"
                notesForCollectionId={tenant?.id}
                companyName={companyName}
                notes={notes}
                setNotes={setNotes}
              />
            ) : null}
          </Col>
          <Col span={24}>
            {companyName ? (
              <Texts
                companyName={companyName}
                collectionName="tenants"
                messages={tenant?.messages}
              />
            ) : null}
          </Col>
          <Col span={24}>
            <Emails />
          </Col>
          <Col span={24}>
            <Letters />
          </Col>
          {/* <Col span={24}>
            <MonthlyCharges data={tenant?.monthlyCharges} />
          </Col> */}
          <Col span={24}>
            <LeaseInformation data={tenant} />
          </Col>
          <Col span={24}>
            <Financials data={tenant} />
          </Col>
          <Col span={24}>{property && <LateFeePolicy />}</Col>
          <Col span={24}>
            <Pets data={tenant} />
          </Col>
          <Col span={24}>
            <Vehicles data={tenant} />
          </Col>
          <Col span={24}>
            <ActionsLog />
          </Col>
          <Col span={24}>
            <AttachmentsUpload
              id={id}
              data={tenant?.attachments}
              companyName={companyName}
              collection="tenants"
              isRefresh={isRefresh}
              setIsRefresh={setIsRefresh}
            />
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={TenantDetailsRightBar} />
      </div>
      <Email
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        emailTo="unit"
      />
      <Modal
        title="Add Additional Tenants from Rental Application"
        centered
        open={isOpenAdditionalTenant}
        onCancel={() => setIsOpenAdditionalTenant(false)}
        footer={
          <div style={{ display: "flex", justifyContent: "start" }}>
            <Button type="primary" onClick={handleOk}>
              Save
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
          </div>
        }
      >
        <Form layout="vertical">
          <Form.Item
            label="Rental Application"
            extra={
              <span>
                or <a href={`/people/tenants/new_tenant/${id}`}>Add Manually</a>
              </span>
            }
            required
          >
            <Select
              options={[
                { value: "Test 1" },
                { value: "Test 2" },
                { value: "Test 3" },
              ]}
              placeholder="Search by name, unit, property, or marketing campaign"
            />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Send Bulk Text"
        centered
        open={isShowModalTextUnit}
        footer={
          <div style={{ display: "flex", justifyContent: "start" }}>
            <Button type="primary" onClick={handleOk} disabled>
              send
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
          </div>
        }
      >
        <Form>
          <h4>Select Recipient(s):</h4>
          <Form.Item>
            <Checkbox disabled>
              Aamir Khan (<a href="#">Why?</a> )
            </Checkbox>
          </Form.Item>
          <Form.Item>
            <TextArea
              showCount
              maxLength={300}
              style={{
                height: 100,
                marginBottom: 24,
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default TenantDetails;
